import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarEvent } from '../../models';
import 'add-to-calendar-button';
import moment from 'moment';

@Component({
    selector: 'lib-export-calendar-dialog',
    templateUrl: './export-calendar-dialog.component.html',
    styleUrls: ['./export-calendar-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExportCalendarDialogComponent implements OnInit {
  public exportOptions: string;
  public eventDates: { startDate: string, startTime: string, endDate: string, endTime: string };

  public EXPORT_TO = ['Google', 'iCal', 'MicrosoftTeams', 'Microsoft365', 'Yahoo'];

  constructor(@Inject(MAT_DIALOG_DATA) public event: CalendarEvent) { }

  ngOnInit(): void {
    const { date, duration } = this.event;

    this.eventDates = date && this.getEventDates(date, duration);
    this.exportOptions = this.EXPORT_TO.map(item => `'${item}'`).join(',')
  }

  private getEventDates(date: Date | string, durationInMinutes: number): any {
    const start = moment(date).utc(false);
    const end = moment(date).utc(false).add(durationInMinutes, 'minutes');

    return {
      startDate: start.format('YYYY-MM-DD'),
      startTime: start.format('HH:mm'),
      endDate: end.format('YYYY-MM-DD'),
      endTime: end.format('HH:mm')
    };
  }
}
